import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputFeedbackComponent } from './input-feedback/input-feedback.component';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    InputFeedbackComponent,
    UploadProgressComponent
  ],
  exports: [
    InputFeedbackComponent,
    UploadProgressComponent
  ]
})
export class InputUtilsModule { }
